/**
 * CKEditor 5: upload adapter custom para definir `FileRepository.createUploadAdapter`.
 * Assim habilitamos upload de imagens sem precisar do pacote `@ckeditor/ckeditor5-upload`.
 */

export function createCkeditorUploadAdapterPlugin({ uploadUrl, headers }) {
  return function UploadAdapterPlugin(editor) {
    const fileRepository = editor.plugins.get("FileRepository");

    fileRepository.createUploadAdapter = (loader) => {
      return new CkeditorUploadAdapter(loader, { uploadUrl, headers });
    };
  };
}

class CkeditorUploadAdapter {
  constructor(loader, { uploadUrl, headers }) {
    this.loader = loader;
    this.uploadUrl = uploadUrl;
    this.headers = headers || {};
  }

  async upload() {
    const file = await this.loader.file;

    const formData = new FormData();
    // Backend aceita `upload` e também `file` (boa compatibilidade)
    formData.append("upload", file);

    const response = await fetch(this.uploadUrl, {
      method: "POST",
      headers: this.headers,
      body: formData,
      // Não enviamos credenciais/cookies: a autenticação já vem via `Authorization` no header.
      // Isso evita conflito de CORS (Access-Control-Allow-Origin: * + credenciais).
      credentials: "omit",
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "");
      throw new Error(text || `Upload failed with status ${response.status}`);
    }

    const data = await response.json();

    // CKEditor espera algo como: { default: "https://..." }
    return {
      default: data.url || data.default || data.uploaded,
    };
  }

  abort() {
    // Implementação opcional: para cancelamento real, armazenar xhr/abortController.
  }
}

